import { QNote } from '@qwealth/qdata';
import { deleteQNote } from 'data/actions/qnotes';
import { useAppDispatch } from 'data/store';
import { FC } from 'react';
import NotesPreviewCard from './PreviewCard/NotesPreviewCard';

interface QNotePreviewProps {
  qnote: QNote;
  editNote: (qnote: QNote) => void;
  setPreviousModalHidden?: React.Dispatch<React.SetStateAction<boolean>>;
}

const QNotePreview: FC<QNotePreviewProps> = ({ qnote, editNote, setPreviousModalHidden }): JSX.Element => {
  const dispatch = useAppDispatch();

  return (
    <NotesPreviewCard
      title={qnote.title}
      uuid={qnote.uuid ? qnote.uuid : ''}
      type="QNote"
      lastUpdated={qnote.date as string}
      lastUpdatedBy={qnote.author as string}
      created={qnote.date as string}
      createdBy={qnote.author as string}
      syncDate={''}
      isWealthbox={qnote.lastUpdatedByWealthbox}
      isSignificantChange={qnote.isSignificantChange === 1}
      isMeaningfulInteraction={qnote.isMeaningfulInteraction === 1}
      isPortfolioReview={qnote.isPortfolioReview === 1}
      handleEdit={() => editNote(qnote)}
      handleDelete={() => {
        dispatch(deleteQNote(qnote.uuid!));
      }}
      setPreviousModalHidden={setPreviousModalHidden}
    />
  );
};

export default QNotePreview;
